import React from 'react';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle, Clock } from 'lucide-react';

export function ManagerRequestsTab({ ctx }) {
  const { shiftRequests, handleShiftRequest, isOwnBranch } = ctx;

  return (
    <div className="bg-white rounded-xl shadow-md border border-stone-200 p-6">
      <h2 className="text-2xl font-bold text-stone-800 mb-6">Pending Shift Requests</h2>
      {shiftRequests.length === 0 ? (
        <div className="text-center py-12 text-stone-500">
          <CheckCircle className="w-12 h-12 mx-auto mb-3 text-stone-400" />
          <p>No pending requests</p>
        </div>
      ) : (
        <div className="space-y-3">
          {shiftRequests.map(request => (
            <div
              key={request.id}
              data-testid={`request-card-${request.id}`}
              className="border border-stone-200 rounded-lg p-4 hover:shadow-md transition"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="font-semibold text-stone-800">{request.username}</span>
                    <span className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full">
                      {request.shift_code}
                    </span>
                  </div>
                  <div className="text-sm text-stone-600">
                    {new Date(request.date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
                  </div>
                  <div className="flex items-center gap-2 mt-1 text-sm text-stone-500">
                    <Clock className="w-4 h-4" />
                    {request.start_time} - {request.end_time} ({request.shift_type})
                  </div>
                </div>
                <div className="flex gap-2">
                  <Button
                    onClick={() => handleShiftRequest(request.id, 'approve')}
                    data-testid={`approve-request-${request.id}`}
                    size="sm"
                    className="bg-green-600 hover:bg-green-700 text-white"
                    disabled={!isOwnBranch}
                  >
                    <CheckCircle className="w-4 h-4 mr-1" />
                    Approve
                  </Button>
                  <Button
                    onClick={() => handleShiftRequest(request.id, 'reject')}
                    data-testid={`reject-request-${request.id}`}
                    size="sm"
                    variant="outline"
                    className="text-red-600 border-red-300 hover:bg-red-50"
                    disabled={!isOwnBranch}
                  >
                    <XCircle className="w-4 h-4 mr-1" />
                    Reject
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
